import React from 'react'

const Footer = () => {
    return (
        <footer>
            <p>&copy; 2024 SavorSphere</p>
        </footer>
    )
}

export default Footer